import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { fetchPublicTrainerSchedule } from '../../../actions/groupSessionsAction';
import {
  fetchLocalLeads,
  configureLeadsForPublicSchedule
} from '../../../actions/users';
import { Row, Col } from '../../common/Grid';
import InfoPopUp from '../../common/InfoPopup';
import { Dropdown, Radio } from '../../common/Inputs/';
import * as T from '../../common/Typography';
import PublicSessionList from '../../common/List/PublicSessionList';
import USER_TYPES from '../../../constants/userTypes';

import Layout from '../../Layouts';
import * as S from './style';
const CourseSchedule = ({
  loading,
  sessions,
  fetchPublicTrainerSchedule,
  configureLeadsForPublicSchedule,
  fetchLocalLeads,
  localLeadsLoading,
  localLeads,
  isMobile,
  role
}) => {
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchPublicTrainerSchedule({});
  }, [fetchPublicTrainerSchedule, localLeads]);

  useEffect(() => {
    if (role === USER_TYPES.admin) {
      fetchLocalLeads();
    }
  }, [role, fetchLocalLeads]);

  const adminPanel = role === USER_TYPES.admin && (
    <S.ControlPanel>
      <T.H1 mb={5}>Configure local leads for public schedule</T.H1>
      <Dropdown
        selected={localLeads
          .filter(({ showSessionsPublicly }) => showSessionsPublicly)
          .map(({ _id }) => _id)}
        m={{ mb: '6' }}
        placeholder="Select as many as you like"
        required
        multi
        options={localLeads.map(lead => ({
          label: lead.name,
          value: lead._id
        }))}
        name="trainers"
        handleChange={ids => {
          configureLeadsForPublicSchedule(ids).then(() =>
            fetchPublicTrainerSchedule({})
          );
        }}
        error={null}
        disabled={localLeadsLoading}
      />
    </S.ControlPanel>
  );

  return (
    <Layout>
      {adminPanel && <Row>{adminPanel}</Row>}
      <Row mb={7}>
        <Col w={[4, 8, 8]}>
          <T.H1 mb={5}>Gwent Connect 5: Available sessions</T.H1>
          <br />
          <T.P>Click to register for any session you would like to attend.</T.P>
          <T.P>
            Please note: Gwent Connect 5 modules must be completed in order.
          </T.P>
          <T.P mt={5} mb={2}>
            <strong>
              Important:
              <br />
              You can book your places on Modules 1, 2 and 3 in advance.
              However, the modules must be attended in order.
              <br />
              <br />
              Module 1 must be completed before you attend Module 2.
              <br />
              Modules 1 and 2 must be completed before you attend Module 3.
            </strong>
          </T.P>
          <T.P>
            You are not required to complete all three modules. However, if you
            wish to complete the full course, you will need to register for each
            module individually.
          </T.P>
          <T.P>
            Courses are available either in person or live online via Microsoft
            Teams.
          </T.P>
          <T.P mt={5}>
            Please note: Each session requires a minimum of six participants to
            proceed. If you are unable to attend, please inform your trainer as
            soon as possible so your place can be offered to someone else.
          </T.P>
          <T.P mt={5}>
            Important message from funders:
            <InfoPopUp
              ml={2}
              title="IMPORTANT MESSAGE FROM FUNDERS"
              text={`Gwent Connect 5 is fully funded by the Welsh Government (WG) and Aneurin Bevan University Health Board (ABUHB) Gwent Public Health Team. In compliance with funding criteria for this free training course and to enable the Gwent Public Health Team to monitor and improve its impact, ALL training participants are required to complete brief evaluation forms. Anonymised responses from completed evaluation forms will be analysed by the Gwent Public Health Team. Results will be reported back to funders to enable the continuation of the programme.`}
              h="16px"
              w="16px"
              color={'primary'}
            />
          </T.P>
        </Col>
      </Row>
      <Row>
        {loading || sessions?.length > 0 ? (
          <>
            <Radio
              name="sessionType"
              handleChange={setFilter}
              options={[
                { label: isMobile ? 'All' : 'All sessions', value: 'all' },
                {
                  label: isMobile ? 'Online' : 'Online sessions',
                  value: 'online'
                },
                {
                  label: isMobile ? 'In-person' : 'In-person sessions',
                  value: 'faceToFace'
                }
              ]}
              value={filter}
            />
            <PublicSessionList
              dataList={
                !loading &&
                sessions.filter(
                  session =>
                    filter === 'all' || session.remote === (filter === 'online')
                )
              }
              linkText={'Book'}
              showTrainer={true}
              showSpaces={true}
              isMobile={isMobile}
            />
            <T.P mt={5}>
              If a session you wish to attend is full, please contact the
              trainer to be added to a waiting list. Click on the session for
              trainer contact details.
            </T.P>
          </>
        ) : (
          <Col w={[4, 8, 8]}>
            <T.P weight={700}>
              No sessions currently available. Check back soon.
            </T.P>
          </Col>
        )}
      </Row>
    </Layout>
  );
};

const mapStateToProps = state => {
  return {
    localLeadsLoading:
      state.loading.fetchLocalLeads |
      state.loading.updateLeadsForPublicSchedule,
    loading: state.loading.fetchSessions,
    sessions: state.sessions.sessions,
    isMobile: state.checkBrowserWidth.isMobile,
    localLeads: state.fetchedData.localLeadsList,
    role: state.auth?.role
  };
};

const mapActionsToProps = {
  fetchPublicTrainerSchedule,
  fetchLocalLeads,
  configureLeadsForPublicSchedule
};

export default connect(mapStateToProps, mapActionsToProps)(CourseSchedule);
